import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textSearch',
  pure: false
})
export class TextSearchPipe implements PipeTransform {
  transform(value: any[], query: string): any[] {
   // console.log(value, query)
      return query
          ? value.filter((rx) => {
            if (rx.patient.full_name.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
              // console.log(query, rx.patient.full_name);
              return rx;
            }
          })
          : value;
  }
  // transform(value: any, query: string, field: string): any {
  //   console.log(value)
  //   return query ? value.reduce((prev, next) => {
  //     if (next[field].includes(query)) { prev.push(next); }
  //     return prev;
  //   }, []) : value;
  // }
}



// WEBPACK FOOTER //
// ./src/pipes/text-search/text-search.ts